/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import Image from 'components/Image';
import s from './MatchCornerWidget.scss';

const customOnError = e => {
  e.target.onerror = null;
  e.target.src = 'https://static.toiimg.com/photo/25581306.cms';
};
const defaultThumb =
  'https://static.toiimg.com/thumb/msid-81945120,width-100,height-100/81945120.jpg';

function getPlayerList(listitem = [], thumbslist, props) {
  return listitem.map(player => {
    let playerkey = player.name && player.name.split(' (')[0];
    playerkey = playerkey
      .split(' ')
      .join('-')
      .toUpperCase();

    return (
      <li>
        <Link
          to={`https://timesofindia.indiatimes.com${player.link}`}
          title={player.name}
          data-newga={`click#playingXI_timesofindia.indiatimes.com${
            player.link
          }${props.gaCategory ? `#${props.gaCategory}` : ''}`}
        >
          <span>
            {thumbslist[playerkey] && thumbslist[playerkey].strimg ? (
              <Image
                key={thumbslist[playerkey].playernameseo}
                src={thumbslist[playerkey].strimg}
                placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                alt={thumbslist[playerkey].playernameseo}
                lazyload
                onError={customOnError}
                offsetVertical={200}
              />
            ) : (
              <Image
                key="default_1"
                src={defaultThumb}
                placeHolderSrc="https://static.toiimg.com/photo/msid-25581306/25581306.jpg"
                alt="default"
                lazyload
                onError={customOnError}
                offsetVertical={200}
              />
            )}
          </span>
          <p>{player.name}</p>
        </Link>
      </li>
    );
  });
}
export default function PlayingXIPopup(props) {
  const [currTab, setCurrTab] = useState(props.currTab);
  let { playingeleven } = props.data;
  const { thumbslist } = props;
  let firstSquad = {};
  let firstTeamName = '';
  let firstTeamPlayers = [];
  let secondSquad = {};
  let secondTeamName = '';
  let secondTeamPlayers = [];

  try {
    if (playingeleven && playingeleven.data && playingeleven.data.length > 0) {
      firstSquad = playingeleven.data[0];
      firstTeamPlayers = (firstSquad && firstSquad.squad_array) || [];
      firstTeamName = (firstSquad && firstSquad.team_name) || '';
      secondSquad = playingeleven.data[1];
      secondTeamPlayers = (secondSquad && secondSquad.squad_array) || [];
      secondTeamName = (secondSquad && secondSquad.team_name) || '';
    }
  } catch (e) {
    playingeleven = undefined;
  }

  return props.showPopup &&
    playingeleven &&
    playingeleven.data &&
    playingeleven.data.length > 0 ? (
    <div className={`playerpopup ${s.playerpopup}`} onClick={props.handleClick}>
      <div className={`playerpopupMid ${s.playerpopupMid}`}>
        <h3>
          PLAYING XI
          <span className={`playerpopupclose ${s.playerpopupclose}`} />
        </h3>
        <ul className={s.teamslisting}>
          {firstSquad ? (
            <li className={currTab === 'first' ? s.active : ''}>
              <Link
                href="javascript: void(0)"
                title={firstTeamName}
                onClick={() => setCurrTab('first')}
              >
                {firstTeamName}
              </Link>
            </li>
          ) : null}
          {secondSquad ? (
            <li className={currTab === 'second' ? s.active : ''}>
              <Link
                href="javascript: void(0)"
                title={secondTeamName}
                onClick={() => setCurrTab('second')}
              >
                {secondTeamName}
              </Link>
            </li>
          ) : null}
        </ul>
        <div className={s.popupplayingelevenlist}>
          <ul>
            {currTab === 'first'
              ? getPlayerList(firstTeamPlayers, thumbslist || {}, props)
              : getPlayerList(secondTeamPlayers, thumbslist || {}, props)}
          </ul>
        </div>
      </div>
    </div>
  ) : null;
}

PlayingXIPopup.propTypes = {
  showPopup: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};
